import { render } from "./CardPackage.vue?vue&type=template&id=71983e5d&scoped=true"
import script from "./CardPackage.vue?vue&type=script&lang=js"
export * from "./CardPackage.vue?vue&type=script&lang=js"

import "./CardPackage.vue?vue&type=style&index=0&id=71983e5d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71983e5d"]])

export default __exports__